import { call, takeLatest } from 'redux-saga/effects';

import type * as VersioningActions from '~/actions/versioning.actions';

import { ActionKeys } from '~/actions/constants';
import * as versioningService from '~/services/versioning.service';
import { camelizeKeys } from '~/utils/humps';

export function* getVersion(action: ReturnType<typeof VersioningActions.getVersion>) {
  try {
    const response = yield call(versioningService.getVersioning);
    action.callback(camelizeKeys(response.data));
  } catch (err) {
    action.callback(err);
  }
}

export function* upgradeVersion(action: ReturnType<typeof VersioningActions.upgradeVersion>) {
  try {
    const response = yield call(versioningService.upgradeVersioning);
    action.callback(response.data);
  } catch (err) {
    action.callback(err);
  }
}

export default [
  takeLatest(ActionKeys.FETCH_VERSION, getVersion),
  takeLatest(ActionKeys.UPGRADE_VERSION, upgradeVersion),
];
